import React from 'react';
import { customizable } from '@fluentui/react';

import { IButtonImplProps } from '../BaseButton.types';
import { PrimaryButton } from '../PrimaryButton';

@customizable('DestructiveButton', ['theme', 'styles'], true)
export class DestructiveButton extends React.Component<IButtonImplProps, Record<string, unknown>> {
  public render(): JSX.Element {
    return <PrimaryButton {...this.props} />;
  }
}
